// @flow
import { useMemo } from 'react';

import type { Klass } from 'app/dataTypes/Klasses.types';
import SimpleDate from 'app/dataProviders/SimpleDate';


const romans = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X', 'XI', 'XII', 'XIII'];

export type Period = {
  title: string,
  link: string,
  current: boolean,
  start: SimpleDate,
  finish: SimpleDate,
}

export default function usePeriods(
  klass: Klass,
  date: SimpleDate,
  createPath: ({ date?: SimpleDate, summary: boolean }) => string
): [Array<Period>, Period | null] {
  const res = useMemo(() => {
    const { schoolyearPeriods } = klass;
    const periodisationTitle = klass.periodisation;
    let currentPeriod = null;
    const periods = (schoolyearPeriods || []).map(({ start, finish }, index) => {
      const period = ({
        title: `${romans[index]} ${periodisationTitle}`,
        link: createPath({ date: start, summary: false }),
        current: date.isBetween(start, finish),
        start,
        finish,
      });
      if (period.current) {
        currentPeriod = period;
      }
      return period;
    });

    return [periods, currentPeriod];
  }, [klass, date, createPath]);

  return res;
}
